import moment from "moment";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { DatePicker } from "src/components/ui";
import DateRangeSelectorNew from "src/components/ui/DateRangeSelectorNew";
import { Text } from "src/components/ui/Text";
import { useDempStore } from "src/context/stores";
import { useTranslation } from 'react-i18next'

const DisplayViewDate = ({ selectedRange, setSelectedRange }) => {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const { t } = useTranslation("main");
  const [timeRange, updateTimeRange, plantId] = useDempStore((state) => [
    state.timeRange,
    state.updateTimeRange,
    state.plantId,
  ]);

  // date picker
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [customActive, setCustomActive] = useState(false);

  const timeRanges = [
    {
      path: "?start=-1h&stop=now()",
      range: t("dateTime.1Hour"),
      shortForm: "1H",
      openCalendar: false,
    },
    {
      path: "?start=-1d&stop=now()",
      range: t("dateTime.1Day"),
      shortForm: "1D",
      openCalendar: false,
    },
    {
      path: "?start=-7d&stop=now()",
      range: t("dateTime.1Week"),
      shortForm: "1W",
      openCalendar: false,
    },
    {
      path: "?start=-1mo&stop=now()",
      range: t("dateTime.1Month"),
      shortForm: "1M",
      openCalendar: false,
    },
    {
      path: "?start=-6mo&stop=now()",
      range: t("dateTime.6Month"),
      shortForm: "6M",
      openCalendar: false,
    },
    {
      path: "?start=-12mo&stop=now()",
      range: t("dateTime.1Year"),
      shortForm: "1Y",
      openCalendar: false,
    },
    {
      path: "?start=all&stop=now()",
      range: t("dateTime.AllTime"),
      shortForm: "ALL",
      openCalendar: false,
    },
    {
      path: `?start=${startDate}&stop=${endDate}`,
      range: t("dateTime.Custom"),
      shortForm: "Custom",
      openCalendar: true,
    },
  ];

  const changeGlobalTimeRange = (range) => {
    setSelectedRange(range);
    if (range !== "custom") {
      updateTimeRange(range);
      localStorage.setItem("timeRange", range);
      navigate(pathname);
    }
  };

  const fetchData = async () => {
    try {
      if (selectedRange === "custom") {
        updateTimeRange(selectedRange);
        localStorage.setItem("timeRange", selectedRange);
        const customPath = `?start=${startDate}&stop=${endDate}`;
        setSelectedRange(customPath);
        navigate(`${pathname}${customPath}`);
      } else {
        updateTimeRange(selectedRange);
        localStorage.setItem("timeRange", selectedRange);
        navigate(pathname);
      }
    } catch (error) {}
  };

  useEffect(() => {
    setCustomActive(
      ![
        "?start=-1h&stop=now()",
        "?start=-1d&stop=now()",
        "?start=-7d&stop=now()",
        "?start=-1mo&stop=now()",
        "?start=-6mo&stop=now()",
        "?start=-12mo&stop=now()",
        "?start=all&stop=now()",
        `?start=${startDate}&stop=${endDate}`,
      ].includes(selectedRange)
    );
  }, [selectedRange, customActive, startDate, endDate]);

  useEffect(() => {
    fetchData();
  }, [selectedRange, startDate, endDate]);

  return (
    <div className="flex items-center gap-2">
      <Text variant="medium-12" className="text-secondary text-nowrap">
        {t('dateTime.display_view')}
      </Text>
      <div className="items-center bg-[#f2f7f6] border border-neutral-200 flex h-9 relative w-fit p-1 rounded-lg border-solid">
        {timeRanges?.map((timeRange, index) => (
          <button
            key={index + "timerange"}
            onClick={() => changeGlobalTimeRange(timeRange?.path)}
            className={` text-[10px] px-2 py-1 rounded-md ${
              selectedRange === timeRange?.path && plantId !== 408
                ? "bg-vekin text-white rounded-lg"
                : selectedRange === timeRange?.path && plantId === 408
                ? "bg-[#ED1C24] text-white rounded-lg"
                : "text-black"
            } ${
              selectedRange === timeRange?.path && plantId === 408
                ? "bg-[#ED1C24] text-white rounded-lg"
                : "text-black"
            }`}
            type="button"
          >
            <span className="hidden xl:block">{timeRange?.range}</span>
          </button>
        ))}
      </div>
      <div className="relative z-20 flex items-center justify-center w-48">
        {/* <DatePicker
          customActive={customActive}
          setCustomRange={setSelectedRange}
          setStartDate={setStartDate}
          setEndDate={setEndDate}
          plantId={plantId}
        /> */}
        <DateRangeSelectorNew
        customActive={customActive}
        setCustomRange={setSelectedRange}
        setStartDate={setStartDate}
        setEndDate={setEndDate}
        plantId={plantId}
        />
      </div>
    </div>
  );
};

export default DisplayViewDate;
